import { useEffect, useState } from "react";
import { ItemsListProps } from "../interface/CommonInterface";
import { useMutation } from "@tanstack/react-query";
import { readCodeEntriesByCodeTypeApi } from "../../../../api/code/CodeApi";
import { typesDetailInterface } from "./interface/TypeListInterface";
import { useModal } from "../../../../hooks";
import { useSetAtom } from "jotai";
import { isLoading } from "../../../../state/Spinner";
import AuthorityChecker from "../../../../components/common/authorityGuard/AuthorityChecker";

export const ItemsList = ({
    types,
    typesDetail,
    setTypesDetail,
    menuId,
    isAddItem,
    setIsAddItem,
    isModify,
    setIsModify,
    isAddComplete,
    setIsAddComplete,
    isDeleteComplete,
    setIsDeleteComplete
}: ItemsListProps) => {
    const { handleModal } = useModal();

    const [typesDetailArr, setTypesDetailArr] = useState<typesDetailInterface[]>([]); // 초기값 null 허용
    const setLoading = useSetAtom(isLoading);

    const readCodeTypeApiMutate = useMutation({
        mutationFn: () => readCodeEntriesByCodeTypeApi(types),
        onSuccess: (res) => {
            if (res.data.code === "0000") {
                setIsModify(false)
                setTypesDetailArr(res.data.result);
                setTypesDetail(res.data.result[0]);
            } else {
                alert("서비스 오류가 있습니다.");
            }
        },
        onError: (error) => {
            alert(`API 호출 중 오류가 발생했습니다: ${error}`);
        },
    });

    useEffect(() => {
        if (types.codeTypeId) {
            setLoading(true)
            readCodeTypeApiMutate.mutate();
        }
        if (isModify) {
            handleModal({ isOpen: true, contents: "수정되었습니다.", type: "alert" })
            setIsModify(!isModify)
        }
        if (isDeleteComplete) {
            handleModal({ isOpen: true, contents: "삭제되었습니다.", type: "alert" })
            setIsDeleteComplete(!isDeleteComplete)
        }
        if (isAddComplete) {
            handleModal({ isOpen: true, contents: "저장되었습니다.", type: "alert" })
            setIsAddComplete(!isAddComplete)
        }
        setLoading(false);
    }, [types, isModify, isAddComplete, isDeleteComplete]);

    return (
        <>
            <div className="item_box2">
                <div className="fiter_top">
                    <h3 className="filter_heading">항목 목록</h3>
                    <div className="filter_toolbar">
                        <AuthorityChecker authorityNames={['itemWriteYn']}>
                            {menuId === 1 ? <button className="btn btn-dark w-80px"
                                onClick={() => setIsAddItem(true)}>추가</button> : null}
                        </AuthorityChecker>
                    </div>
                </div>
                <ul className="list_items">
                    {typesDetailArr && typesDetailArr.length > 0 ? (
                        typesDetailArr.map((item: any) => (
                            <li
                                key={item.codeEntriesId || item.crmCodeId} // 고유 key 설정
                                className={(() => {
                                    if (!isAddItem) {
                                        if (item.codeEntriesId !== null) {
                                            return typesDetail.codeEntriesId === item.codeEntriesId ? "active" : "";
                                        } else {
                                            return typesDetail.crmCodeId === item.crmCodeId ? "active" : "";
                                        }
                                    }
                                })()}
                            >
                                <a onClick={() => setTypesDetail(item)}>{item.codeEntriesName}</a>
                            </li>
                        ))
                    ) : (
                        <div className="pt-15px" style={{ textAlign: "center" }}>
                            데이터가 없습니다.
                        </div>
                    )}
                </ul>
            </div>
        </>
    );
};
